import React from 'react';
import FlyerAkustik from '../../assets/images/RiGAkustik_26.png'

/**
 * @param {React.HTMLProps<HTMLImageElement>} props
 */
export default function RigAkustikFlyer(props = {}) {
  const { src, srcHover, flyerAltTextAkustik, ...imgProps } = props
  const flyerSrc = src ?? FlyerAkustik
  const flyerSrcHover = srcHover ?? flyerSrc

  return (
    <div className="container">
      <img
        alt={flyerAltTextAkustik + ' - Front'}
        src={flyerSrc}
        {...imgProps}
      />
      {flyerSrcHover && flyerSrcHover !== flyerSrc && (
        <img
          alt={flyerAltTextAkustik + ' - Back'}
          src={flyerSrcHover}
          {...imgProps}
        />
      )}
    </div>
  )
}
